<template>

    <div>

        <div class="mb-3" style="max-width: 400px;">

            <div v-for="(file, index) in files" :key="index">

                <table style="width: 100%; font-size: .875rem;">
                    <tr>
                        <td class="text-truncate" style="max-width:1px;">
                            <a v-bind:href="file" target="_blank">{{ getNameFromUrl(file) }}</a>
                        </td>
                        <td style="width: 40px;"><a href="javascript:void(0)" @click="clear(index)" class="text-danger">{{ t.__('Usuń') }}</a></td>
                    </tr>
                </table>

                <input type="hidden" :name="inputName + '[' + index + ']'" v-model="files[index]">

            </div>

        </div>

        <div>
            <a href="javascript:void(0)" class="btn btn-primary" @click="showFileManager()">{{ t.__('Dodaj') }}</a>
        </div>

    </div>

</template>

<script>
    export default {
        props: ['eventHub', 'inputName', 'currentValue', 'mimeTypes'],
        data() {
            return {
                files: [],
                newFile: null
            }
        },
        methods: {
            showFileManager() {
                this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes)
            },
            clear(index) {
                this.files.splice(index, 1);
            },
            getNameFromUrl(url) {
                return url.substring(url.lastIndexOf('/')+1);
            }
        },
        mounted() {
            if (CONFIG.oldInput.hasOwnProperty(this.inputName))  {
                this.files = CONFIG.oldInput[this.inputName];
            } else if (this.currentValue != null) {
                this.files = this.currentValue;
            }

            this.eventHub.$on('file-manager-selected-' + this._uid, (file) => {
                this.files.push(file.webPath);
                this.eventHub.$emit('hide-file-manager')
            });
        }
    };
</script>
